<template>
  <div :class="{ 'ful-section': !bare }" v-if="basicTableArray.length > 0">
    <!-- bare 模式：可折叠 -->
    <div v-if="bare">
      <div @click="collapsed = !collapsed" class="ful-collapse-trigger" role="button" tabindex="0"
        @keydown.enter.prevent="collapsed = !collapsed" @keydown.space.prevent="collapsed = !collapsed">
        <!-- <span class="ful-inner-section-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
        </span> -->
        <div class="ful-collapse-title" v-if="showTriggerTitle">
          <h2 class="ful-inner-section-title">{{ chaoweiMode ? '健康问询' : '症状信息' }}</h2>
        </div>
        <span class="ful-collapse-hint">{{ collapsed ? '点击展开' : '点击收起' }}</span>
        <svg class="ful-chevron" :class="{ 'is-open': !collapsed }" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </div>
    </div>
    <div v-else class="ful-section-heading">
      <svg class="ful-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
      <h2 class="ful-section-title">症状信息</h2>
    </div>

    <!-- 折叠内容：结构性症状分组 -->
    <div :class="['ful-collapse-body', { 'is-collapsed': bare && collapsed }]">
      <div class="symptom-list">
        <!-- 基本情况 / 脉象 -->
        <div class="symptom-group" v-if="basicTableArray.length > 0">
          <div class="symptom-group-title">{{ chaoweiMode ? '基本情况' : '基本情况 / 脉象' }}</div>
          <div class="info-grid">
            <div class="info-item" v-for="item in basicTableArray" :key="item.key" v-if="isValidItem(item)">
              <span class="info-label">{{ chaoweiMode && item.key === '主诉' ? '问询结果' : item.key }}：</span>
              <span class="info-value">{{ formatValue(item.value) }}</span>
            </div>
          </div>
        </div>

        <!-- 三焦辨证 -->
        <template v-if="hasSanJiaoData">
          <div class="divider"></div>
          <div class="symptom-group">
            <div class="symptom-group-title">{{ chaoweiMode ? '三焦情况' : '三焦辨证' }}</div>
            <div class="sanjiao-list">
              <div class="sanjiao-group" v-if="hasValidShangJiao">
                <div class="sanjiao-group-title">上焦</div>
                <div class="info-grid">
                  <div class="info-item" v-for="item in shangjiaoTableArray" :key="item.key" v-if="isValidItem(item)">
                    <span class="info-label">{{ item.key }}：</span>
                    <span class="info-value">{{ formatValue(item.value) }}</span>
                  </div>
                </div>
              </div>
              <div class="sanjiao-group" v-if="hasValidZhongJiao">
                <div class="sanjiao-group-title">中焦</div>
                <div class="info-grid">
                  <div class="info-item" v-for="item in zhongjiaoTableArray" :key="item.key" v-if="isValidItem(item)">
                    <span class="info-label">{{ item.key }}：</span>
                    <span class="info-value">{{ formatValue(item.value) }}</span>
                  </div>
                </div>
              </div>
              <div class="sanjiao-group" v-if="hasValidXiaJiao">
                <div class="sanjiao-group-title">下焦</div>
                <div class="info-grid">
                  <div class="info-item" v-for="item in xiajiaoTableArray" :key="item.key" v-if="isValidItem(item)">
                    <span class="info-label">{{ item.key }}：</span>
                    <span class="info-value">{{ formatValue(item.value) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SymptomTable',
  props: {
    basicTableArray: { type: Array, default: () => [] },
    shangjiaoTableArray: { type: Array, default: () => [] },
    zhongjiaoTableArray: { type: Array, default: () => [] },
    xiajiaoTableArray: { type: Array, default: () => [] },
    hasShangJiao: { type: Boolean, default: false },
    hasZhongJiao: { type: Boolean, default: false },
    hasXiaJiao: { type: Boolean, default: false },
    bare: { type: Boolean, default: false },
    showTriggerTitle: { type: Boolean, default: true },
    // 超微饮片模式：折叠标题改为「健康问询」，基本情况去掉「/ 脉象」
    chaoweiMode: { type: Boolean, default: false }
  },
  data() {
    return { collapsed: true }
  },
  computed: {
    hasValidShangJiao() {
      return this.shangjiaoTableArray.some(item => this.isValidItem(item))
    },
    hasValidZhongJiao() {
      return this.zhongjiaoTableArray.some(item => this.isValidItem(item))
    },
    hasValidXiaJiao() {
      return this.xiajiaoTableArray.some(item => this.isValidItem(item))
    },
    hasSanJiaoData() {
      return this.hasValidShangJiao || this.hasValidZhongJiao || this.hasValidXiaJiao
    }
  },
  methods: {
    isValidItem(item) {
      if (!item || !item.hasOwnProperty('value')) return false
      var val = this.formatValue(item.value)
      return val !== '' && val !== null && val !== undefined && val !== '正常'
    },
    formatValue(value) {
      if (Array.isArray(value)) {
        return value.join('，')
      }
      if (typeof value === 'string') {
        return value.replace(/,/g, '，')
      }
      return value
    }
  }
}
</script>
